<template>
  <div class="zong">
    <div :id="groupId" class="echart_container"></div>
  </div>
</template>
<script>
import * as echarts from "echarts";
import { smallCardStatusCount } from "@/api/api.js";//小流量数据
export default {
  props:{
    groupId:{
      type:String,
      require:true
    }
  },
  data() {
    return {
      pielistData:[]
    };
  },
  watch: {},
  computed:{},
  methods: {
    initData(){
      setTimeout(() => {
        var option = {
          title: {
            text: '',
          },
          tooltip: {
            trigger: 'item',
          },
          legend: {
            top: 'bottom',
          },
          series: [
            {
              name: '流量卡状态图表',
              type: 'pie',
              radius: ['35%', '70%'],//设置环形饼图，第一个值设置内圈大小，第二个值设置外圈大小
              center: ['50%', '50%'],
              itemStyle: {
                borderRadius: 8,
                borderColor: '#fff',
                borderWidth: 2
              },
              labelLine: {
                show: true,
              },
              data: this.pielistData
            }
          ]
        };
        var myChart = echarts.init(document.getElementById(this.groupId));
        option && myChart.setOption(option);
        window.addEventListener("resize",function(){
          myChart.resize();
        });
      },80)
    },
    smallFlow(refresh){
      let params = {groupId:this.groupId,refresh}
      smallCardStatusCount(params).then(res =>{
        this.pielistData = res.data.data;
        this.initData();
      })
    },
    // 截取小数点的方法
    formatDecimal(num, decimal) {
      num = num.toString();
      let index = num.indexOf('.');
      if (index !== -1) {
        num = num.substring(0, decimal + index + 1);
      } else {
        num = num.substring(0);
      }
      return parseFloat(num).toFixed(decimal);
    },
  },
  mounted() {
    this.smallFlow(0);
  },
};
</script>
<style scoped lang="less">
  .zong{
    width: 100%;
    height: 280px;
    background: #fff;
    text-align: center;
    border-radius: 8px;
  }
  .echart_container{
    width: 100%;
    height: 280px;
  }
</style>


